import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";
import {
  MrfiktivCustomerAccountControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerCustomerUserViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import customerAccountService from "@/services/shared/customerAccountService";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module, Mutation } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { PaginationFilterListElement } from "./base-pagination.store";
import { CustomerAccountDataAccessLayer } from "./access-layers/customer-account.access-layer";
import { CustomerAccountPageDataProvider } from "./page-data-provider/customer-account.page-data-provider";

/**
 * Store for the end user customer account data.
 */
@Module({
  dynamic: true,
  namespaced: true,
  name: "customerAccountStore",
  store
})
export class CustomerAccountStore extends PaginatedBaseStore<
  MrfiktivPartnerCustomerUserViewModelGen,
  MrfiktivCustomerAccountControllerFindAllByPartnerIdParamsGen
> {
  protected _data = CustomerAccountDataAccessLayer;

  protected _pageProvider = CustomerAccountPageDataProvider;

  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = [
    { key: "_id", type: PageFilterTypes.OBJECT_ID },
    { key: "firstName", type: PageFilterTypes.STRING },
    { key: "firstName", type: PageFilterTypes.STRING },
    { key: "userName", type: PageFilterTypes.STRING },
    { key: "countryCode", type: PageFilterTypes.STRING },
    { key: "userId", type: PageFilterTypes.OBJECT_ID },
    { key: "timestamp.created", type: PageFilterTypes.DATE },
    { key: "isActive", type: PageFilterTypes.BOOLEAN },
    { key: "isMarketingOptIn", type: PageFilterTypes.BOOLEAN }
  ].map(f => new PaginationFilterListElement(f));

  _currentAccount: MrfiktivPartnerCustomerUserViewModelGen | null = null;

  /**
   * Selected customer account
   */
  get currentAccount() {
    return this._currentAccount;
  }

  @Mutation
  private _mutateCurrentAccount(account: MrfiktivPartnerCustomerUserViewModelGen) {
    this._currentAccount = account;
  }

  @Action
  async getOne(data: { partnerId: string; id: string }) {
    const account = await customerAccountService.findOne(data.partnerId, data.id);
    this.context.commit("_mutateCurrentAccount", account);

    return account;
  }
}

export const CustomerAccountModule = getModule(CustomerAccountStore);
